import {
  AffectedStaffDailyReport,
  AffectedStaffDailyReportInput
} from '../../lib/types/models/affectedStaff/affected-staff-daily-report'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function submitAffectedStaffDailyReport(data: {
  input: AffectedStaffDailyReportInput
  affectedStaffId: number
}) {
  const { affectedStaffId: id, input } = data

  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.submitAffectedStaffDailyReport.url, { id }))
    .post<AffectedStaffDailyReport>(input)
}
